/**
 *
 * ActionButton
 *
 */

import * as PropTypes from "prop-types";
import styled from "styled-components";
import {FormattedMessage, injectIntl} from "react-intl";
import messages from "./messages";
import UserMessages from "containers/newTreatment/NewTreatmentUserStep/messages";
import GlobalMessages from "messages/messages";
import moment from "moment";
import { DEFAULT_LOCALE } from "i18n";

const REFERENCE_DENTURE_AND_INTRA_ORAL_SCAN_8 = 8;
const TRY_IN_FIXATING_CLIPS_PLACEMENT_10 = 10;
const REFERENCE_DENTURE_AND_INTRA_ORAL_SCAN_11 = 11;
const TRY_IN_FIXATING_CLIPS_PLACEMENT_14 = 14;
const INTRA_ORAL_SCAN_AND_BITE_REGISTRATION = 15;


function field(headerMessage, content) {
  return (
    <PatientInfoWrapper>
      <PatientDetailSpan>
        <FormattedMessage {...headerMessage} />
      </PatientDetailSpan>
      <PatientDetailContent>{content}</PatientDetailContent>
    </PatientInfoWrapper>
  );
}

//here

function MapTime(counts, times, value){
  for(var i = counts.length - 1; i >= 0; i--){
      if(value >= counts[i]){
          return times[i];
      }
  }
  return times[0];
}

function PatientDetails(props) {
  const { treatment, date, time, patient, result, insurers } = props;
  let insurer = <FormattedMessage {...GlobalMessages.other} />;
  const implantCount =
    treatment.upperImplantCount + treatment.lowerImplantCount;
  if (patient.careId) {
    insurer = insurers.find(i => i.id === patient.careId);
    if (insurer) {
      insurer = insurer.name;
    }
  }

  let additionalDuration = 0;

  if ([REFERENCE_DENTURE_AND_INTRA_ORAL_SCAN_8, REFERENCE_DENTURE_AND_INTRA_ORAL_SCAN_11, INTRA_ORAL_SCAN_AND_BITE_REGISTRATION].includes(treatment.treatmentId)) {
    additionalDuration = MapTime([1,4,6,9],[0,10,20,40],implantCount)
    // if (implantCount <= 6) {
    //   additionalDuration = 5;
    // } else {
    //   additionalDuration = 10;
    // }
  }

  if ([TRY_IN_FIXATING_CLIPS_PLACEMENT_10, TRY_IN_FIXATING_CLIPS_PLACEMENT_14].includes(treatment.treatmentId)) {
    additionalDuration = MapTime([1,4,6,9],[0,10,15,20],implantCount)
    
    // if (implantCount <= 4) {
    //   additionalDuration = 10;
    // } else {
    //   additionalDuration = 15;
    // }
  }

  let duration = 0;
  duration = treatment.duration + additionalDuration;
  if (result.planned_date_time_from && result.planned_date_time_to) {
    const from = moment(result.planned_date_time_from);
    const to = moment(result.planned_date_time_to);
    
    duration = moment.duration(to.diff(from)).asMinutes();
    duration = Math.round(duration / 5) * 5
  }

  var timemoment = moment(time,['H:m'])

  timemoment.minutes(Math.round(timemoment.minutes() / 5) * 5)

  return (
    <Wrapper>
      <PatientInfo>
        <PatientInfoWrapper>
          <PatientDetailSpan>
            <FormattedMessage {...messages.patient_id} />
          </PatientDetailSpan>
          <PatientId>{patient.id}</PatientId>
        </PatientInfoWrapper>
        {insurer && field(GlobalMessages.insurer, insurer)}
        {field(UserMessages.internalRef, patient.internalRef)}
        {field(messages.treatment, result.treatmentName)}
        {field(messages.treatment_type, result.endProductTypeName)}
        {field(GlobalMessages.duration, duration + ' minuten')}
        {field(messages.date, date)}
        {field(messages.time, timemoment.format('H:mm'))}
      </PatientInfo>
    </Wrapper>
  );
}

const Wrapper = styled.div``;

const PatientInfo = styled.div`
  display: flex;
  flex-flow: column;
  width: 24rem;

  ${({ theme }) => theme.phone`
    width: 100%;
  `};

  @media (min-width: 1048px) {
    width: 30rem;
  }
`;

const PatientId = styled.div`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-weight: 700;
  padding-left: ${({ theme }) => theme.padding}rem;
  text-align: left;
  width: 100%;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const PatientInfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: ${({ theme }) => theme.padding}rem;
  padding-left: ${({ theme }) => theme.padding}rem;
  padding-right: ${({ theme }) => theme.padding}rem;
`;

const PatientDetailSpan = styled.div`
  padding-right: ${({ theme }) => theme.padding}rem;
  width: 100%;
  text-align: left;
`;

const PatientDetailContent = styled.div`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-weight: 700;
  padding-left: ${({ theme }) => theme.padding}rem;
  text-align: left;
  width: 100%;
`;

PatientDetails.propTypes = {
  patient: PropTypes.object.isRequired,
  treatment: PropTypes.object.isRequired,
  date: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
};

export default injectIntl(PatientDetails);
